<template>
    
</template>



<script>
export default {
    name: 'login',
    data () {
        return {

        }
    },
    mounted () {
        this.Default()
    },
    methods: {
        Default () {
            debugger
            var self = this
            var IdUsuario = self.$route.params.idusuario
            let idPrograma = '5829EFDC-F7CD-4CF0-854C-EAE507F6CD0C'
            var token = self.$route.params.__token
            console.log(IdUsuario)
            //console.log(token)
            var urip = 'api/Usuario/getUser'
            if (IdUsuario === 0) {
                window.location.href = self.$uriUsuarios
            } else {
                var loginUser = {
                    "idUsuario": IdUsuario
                }
                // console.log(loginUser)                
                self.$axios.get(`api/Usuario/GetUser/${IdUsuario}/${idPrograma}`)
                    .then(s => {
                        console.log(s)
                        if (s.data.exito) {
                            self.$store.dispatch('setIsLogin', true)
                            self.$store.dispatch('setUser', s.data.datos)
                       
                            self.GetCloudMessToken(self.$firebase, this, IdUsuario);
                            console.log('self.$store.state.sIsLogin')
                            console.log(self.$store.state.sIsLogin)
                        }
                        else {
                            //window.location.href = self.$uriUsuarios
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
        },
        GetCloudMessToken(firebase, ctx, idUsuario){
                debugger

                var self = ctx;

             var firebaseConfig = {
                apiKey: "AIzaSyAeqO4lHvEYnIjgPShNc2LbFtbPGBvsyIg",
                authDomain: "cosmiccontigoweb.firebaseapp.com",
                databaseURL: "https://cosmiccontigoweb.firebaseio.com",
                projectId: "cosmiccontigoweb",
                storageBucket: "cosmiccontigoweb.appspot.com",
                messagingSenderId: "619943031478",
                appId: "1:619943031478:web:9bef57d9e5e46c7072ac17",
                measurementId: "G-QRKVJC82H7"
                };


            // Initialize Firebase
            firebase.initializeApp(firebaseConfig);

            // Retrieve Firebase Messaging object.
            const messaging = firebase.messaging();

            messaging.usePublicVapidKey("BE6ItL_8D9N5x5MM7SPBlqIaQeSWxQmJRrFU6sOFqo6TYk6XQGTnsnIt5yE8SFUI7SoP5a7m37HuocQu2373Tl4"); // 1. Generate a new key pair

            // Request Permission of Notifications
            messaging.requestPermission().then(() => {
            console.log('Notification permission granted.');
            debugger

            // Get Token
            messaging.getToken().then((token) => {
                console.log(token)
            debugger
                //  let idUsuario = $route.params.idusuario;
                  
                    self.$axios.get('api/TokenNotification/Save?token=' + token + "&idUsuario=" + idUsuario)
                    .then(s => {
                        if(s.data.exito) {
                          console.log(s.data.mensaje)
                        } else {
                          console.log(s.data.mensaje)
                        }
                    })
                    .catch(e => {                     
                         console.log(e)
                    })


            }).catch((err) => {
                if (err.code === "messaging/token-unsubscribe-failed")
                {
                    console.log('Unable to get permission to notify1.', err);
                    messaging.getToken().then((token) => {
                            console.log(token)
                        })
                }
            });
            }).catch((err) => {
                 console.log('Unable to get permission to notify.', err);
            });
        }
    }
}
</script>
